import { render, staticRenderFns } from "./ProblemList.vue?vue&type=template&id=6dfb3e36&"
import script from "./ProblemList.vue?vue&type=script&lang=ts&"
export * from "./ProblemList.vue?vue&type=script&lang=ts&"
import style0 from "./ProblemList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports